<template>
  <search-item
    :company-logo="document.project.company.logo"
    :project-number="document.project.project_number"
    :reference="`#${document.requisition_number}`"
    :title="document.reference_name"
    :to="{ name: 'requisitions-id', params: { id: document.id } }"
    :user="document.created_by"
    @click="$emit('click')"
  />
</template>

<script setup>
import SearchItem from '@/components/search/search-item.vue'

defineEmits(['click'])

defineProps({
  document: {
    type: Object,
    required: true
  },
})
</script>
